import { render } from "./PhotoCard.vue?vue&type=template&id=5f101cbc&ts=true"
import script from "./PhotoCard.vue?vue&type=script&lang=ts"
export * from "./PhotoCard.vue?vue&type=script&lang=ts"

import "./PhotoCard.vue?vue&type=style&index=0&id=5f101cbc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__